import Layout from '../layout/Layout';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useState, useEffect, useRef } from 'react';
import { loadCSS } from '../utils/cssLoader';

// Import SVG icons
import { ReactComponent as HonIcon } from '../components/hon.svg';
import { ReactComponent as ComIcon } from '../components/com.svg';
import { ReactComponent as ResIcon } from '../components/res.svg';
import { ReactComponent as SerIcon } from '../components/ser.svg';

export default function Nosotros() {
    // Animated Counter Component
    const AnimatedCounter = ({ end, suffix = "", duration = 2000 }) => {
        const [count, setCount] = useState(0);
        const [isVisible, setIsVisible] = useState(false);
        const counterRef = useRef(null);

        useEffect(() => {
            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting && !isVisible) {
                        setIsVisible(true);
                    }
                },
                { threshold: 0.5 }
            );

            if (counterRef.current) {
                observer.observe(counterRef.current);
            }

            return () => observer.disconnect();
        }, [isVisible]);

        useEffect(() => {
            if (!isVisible) return;

            let startTime;
            const animate = (currentTime) => {
                if (!startTime) startTime = currentTime;
                const progress = Math.min((currentTime - startTime) / duration, 1);
                
                // Easing function for smooth animation
                const easeOutQuart = 1 - Math.pow(1 - progress, 4);
                setCount(Math.floor(end * easeOutQuart));

                if (progress < 1) {
                    requestAnimationFrame(animate);
                }
            };

            requestAnimationFrame(animate);
        }, [isVisible, end, duration]);

        return (
            <span ref={counterRef} className="stat-number">
                {count}{suffix}
            </span>
        );
    };

    const valores = [
        {
            valor: "Honestidad",
            icon: <HonIcon style={{ maxHeight: '6rem', maxWidth: '6rem', color: '#007bff' }} />,
            desc: "Actuamos con transparencia y ética en todas nuestras  acciones."
        },
        {
            valor: "Responsabilidad",
            icon: <ComIcon style={{ maxHeight: '6rem', maxWidth: '6rem', color: '#007bff' }} />,
            desc: "Asumimos con  seriedad cada proyecto, garantizando calidad y cumplimiento"
        },
        {
            valor: "Compromiso",
            icon: <ResIcon style={{ maxHeight: '6rem', maxWidth: '6rem', color: '#007bff' }} />,
            desc: "Ponemos siempre al cliente en el centro, ofreciendo  atención personalizada y cercana."
        },
        {
            valor: "Servicio",
            icon: <SerIcon style={{ maxHeight: '6rem', maxWidth: '6rem', color: '#007bff' }} />,
            desc: "Nos dedicamos plenamente a cumplir y superar las  expectativas de nuestros clientes"
        }
    ];

    // SVG Icons Components
    const PhoneIcon = () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style={{ color: '#007bff' }}>
            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
        </svg>
    );

    const EmailIcon = () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style={{ color: '#007bff' }}>
            <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
        </svg>
    );

    const LocationIcon = () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style={{ color: '#007bff' }}>
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
        </svg>
    );

    const datos = [
        {
            dato: "228 366 7786",
            logo: <PhoneIcon />
        },
        {
            dato: "+52 228 366 7786",
            logo: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style={{ color: '#007bff' }}>
                    <path d="M21 15.46l-5.27-.61-2.52 2.52a15.045 15.045 0 0 1-6.59-6.59l2.53-2.53L8.54 3H3.03C2.45 13.18 10.82 21.55 21 20.97v-5.51z"/>
                </svg>
            )
        },
        {
            dato: "ventas_orsan@hotmail.com",
            logo: <EmailIcon />
        },
        {
            dato: "Xalapa",
            logo: <LocationIcon />
        },
    ]

    // Load CSS files for Nosotros page
    useEffect(() => {
        loadCSS('Nosotros.css');
    }, []);

    return (
        <Layout>
            <Header active="nosotros" />
            <main style={{flex: 1}}>
            <div style={{ fontFamily: 'Inclusive Sans', textAlign: 'left' }}>


                <div className="hero-section" style={{
                    backgroundImage: 'url(/Orsan/FotoSN.jpeg)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                }}>
                    <div className="hero-overlay"></div>
                    <div className="hero-content">
                        <h1 className="hero-title">ORSAN Consorcio Inmobiliario</h1>
                        <p className="hero-subtitle">Brindamos asesoría integral y soluciones confiables en el sector inmobiliario</p>
                        <div className="hero-stats">
                            <div className="stat-item">
                                <AnimatedCounter end={15} suffix="+" />
                                <span className="stat-label">Años de Experiencia</span>
                            </div>
                            <div className="stat-item">
                                <AnimatedCounter end={500} suffix="+" />
                                <span className="stat-label">Propiedades Vendidas</span>
                            </div>
                            <div className="stat-item">
                                <AnimatedCounter end={100} suffix="%" />
                                <span className="stat-label">Satisfacción</span>
                            </div>
                        </div>
                    </div>
                </div>


                <section className="about-section">
                    <div className="container">
                        <div className="section-header">
                            <h2 className="section-title">Somos tu Mejor Aliado en el Mundo Inmobiliario</h2>
                            <div className="title-underline"></div>
                        </div>
                        <div className="about-content">
                            <div className="about-image">
                                <img src="Orsan/cristal.webp" alt="Edificio Orsan" className="about-img" />
                                <div className="image-overlay">
                                    <div className="overlay-content">
                                        <span className="overlay-text">Excelencia en Bienes Raíces</span>
                                    </div>
                                </div>
                            </div>
                            <div className="about-text">
                                <p className="about-description">
                                    Conformado por un equipo con amplia experiencia en construcción, bienes raíces, 
                                    remates bancarios, ventas y atención al cliente, nuestro enfoque es integral y 
                                    está basado en valores sólidos como la honestidad, el compromiso y la responsabilidad.
                                </p>
                                <div className="about-features">
                                    <div className="feature-item">
                                        <div className="feature-icon">✓</div>
                                        <span>Experiencia comprobada</span>
                                    </div>
                                    <div className="feature-item">
                                        <div className="feature-icon">✓</div>
                                        <span>Atención personalizada</span>
                                    </div>
                                    <div className="feature-item">
                                        <div className="feature-icon">✓</div>
                                        <span>Valores sólidos</span>
                                    </div>
                                </div>
                                <a href="https://www.google.com/maps?q=INMUEBLES+ORSAN,+P.%C2%BA+de+los+Alpes+21,+Residential+Las+Cumbres,+Real+del+Bosque,+91190+Xalapa-Enr%C3%ADquez,+Ver.&ftid=0x85db33b26b5bf855:0x866d0699f3d892f9&hl=es-MX&gl=mx&g_ep=EgY1LjQzLjUYAEICTVg%3D&skid=bab0b568-4c76-442f-b90c-5957db03551e&shorturl=1" 
                                   className="cta-button" target='_blank' rel="noreferrer">
                                    <span>VER UBICACIÓN</span>
                                    <div className="button-icon">→</div>
                                </a>
                            </div>
                        </div>
                    </div>
                </section>


                <section className="services-section">
                    <div className="container">
                        <div className="section-header">
                            <h2 className="section-title">NUESTROS SERVICIOS</h2>
                            <div className="title-underline"></div>
                            <p className="section-subtitle">Soluciones integrales para todas tus necesidades inmobiliarias</p>
                        </div>
                        <div className="services-grid">
                            {[
                                { 
                                    label: 'Administración de Propiedades', 
                                    src: 'Orsan/admin.webp',
                                    description: 'Gestión profesional y mantenimiento de tu inversión inmobiliaria'
                                },
                                { 
                                    label: 'Venta, Renta y Compra', 
                                    src: 'Orsan/venta.webp',
                                    description: 'Transacciones seguras con asesoría especializada'
                                },
                                { 
                                    label: 'Remates Inmobiliarios', 
                                    src: 'Orsan/remate.webp',
                                    description: 'Oportunidades únicas de inversión en el mercado'
                                },
                                { 
                                    label: 'Construcción y Mantenimiento', 
                                    src: 'Orsan/mantenn.webp',
                                    description: 'Servicios integrales de construcción y remodelación'
                                },
                            ].map((item, i) => (
                                <div key={i} className='service-card'>
                                    <div className="service-image">
                                        <img src={`/${item.src}`} alt={item.label} />
                                        <div className="service-overlay">
                                            <div className="service-content">
                                                <h3 className="service-title">{item.label}</h3>
                                                <p className="service-description">{item.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                                <section className="values-section">
                    <div className="container">
                        <div className="section-header">
                            <h2 className="section-title">NUESTROS VALORES</h2>
                            <div className="title-underline"></div>
                            <p className="section-quote">
                                "Cada propiedad representa más que una transacción: es parte del patrimonio y los sueños de nuestros clientes"
                            </p>
                        </div>
                        <div className="values-grid">
                            {valores.map((val, index) => (
                                <div key={index} className='value-card'>
                                    <div className="value-icon">
                                        {val.icon}
                                    </div>
                                    <h3 className="value-title">{val.valor}</h3>
                                    <p className="value-description">{val.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>


                <section className="contact-section">
                    <div className="container">
                        <div className="contact-content">
                            <div className="contact-info">
                                <div className="section-header">
                                    <h2 className="section-title">Orsan Consorcio Inmobiliario</h2>
                                    <div className="title-underline"></div>
                                </div>
                                <div className="contact-description">
                                    <p>En ORSAN Consorcio Inmobiliario te ofrecemos soluciones confiables y personalizadas para comprar, vender, rentar o administrar tu propiedad en Xalapa y la región. Nuestra experiencia, compromiso y servicio integral nos convierten en tu mejor aliado en el mundo inmobiliario.</p>
                                </div>
                                <div className="business-hours">
                                    <h4 className="hours-title">Horario de Atención:</h4>
                                    <p className="hours-text">Lunes a Viernes <span className="hours-time">11:00 AM - 7:00 PM</span></p>
                                </div>
                            </div>
                            <div className="contact-map">
                                <div className="map-container">
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3760.520409435498!2d-96.8740443247834!3d19.51925888177871!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85db33b26b5bf855%3A0x866d0699f3d892f9!2sINMUEBLES%20ORSAN!5e0!3m2!1ses-419!2smx!4v1751784020755!5m2!1ses-419!2smx"
                                        width="100%"
                                        height="300"
                                        style={{ border: 0, borderRadius: '1rem' }}
                                        allowFullScreen=""
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                        title="Ubicación Orsan Consorcio Inmobiliario"
                                    ></iframe>
                                    
                                    <div className="contact-address">
                                        <p>P.º de los Alpes 21, Residential Las Cumbres, Real del Bosque, 91190 Xalapa-Enríquez, Ver.</p>
                                    </div>

                                    <div className="contact-details">
                                        {datos.map((item, index) => (
                                            <div key={index} className="contact-item">
                                                <div className="contact-icon">{item.logo}</div>
                                                <span className="contact-text">{item.dato}</span>
                                            </div>
                                        ))}
                                    </div>

                                    <a
                                        href="https://www.google.com/maps?q=INMUEBLES+ORSAN,+P.%C2%BA+de+los+Alpes+21,+Residential+Las+Cumbres,+Real+del+Bosque,+91190+Xalapa-Enr%C3%ADquez,+Ver."
                                        className="cta-button map-button"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <span>VER UBICACIÓN</span>
                                        <div className="button-icon">→</div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>








            </div>


            </main>

            <div className="footer-wrapper">
                <Footer />
            </div>
        </Layout>
    );
}